import { useEffect, useState } from "react";
import {
  Container,
  Dropdown,
  Placeholder,
  Table,
  Button,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HeadPage } from "src/componentes";
import { IRoute } from "src/interfaces/IRoute";
import RelatorioSistemaCode from "./RelatorioSistema.Code";

const RelatorioSistemaView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const code = RelatorioSistemaCode();

  useEffect(() => {
    setMenuItens([
      { name: "Novo Relatório", route: "/relatorio/sistema/cadastro" },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickPropriedades = (item: any) => () => {
    navigate(`/relatorio/sistema/cadastro?id=${item.id}`);
  };

  return (
    <Container>
      <HeadPage headText="Relatórios do Sistema">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>

      {!code.loading ? (
        <Table responsive hover className="mt-4">
          <thead>
            <tr>
              <th className="col-4">Nome</th>
              <th className="col-4">Módulo</th>
              <th className="col-4">Submódulo</th>
            </tr>
          </thead>
          <tbody>
            {code.data && code.data.length > 0 ? (
              code.data.map((item) => (
                <tr
                  key={item.id}
                  onClick={handleClickPropriedades(item)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="col-4">{item.nome}</td>
                  <td className="col-4">{item.modulo === 0 ? "Fiscal" : item.modulo}</td>
                  <td className="col-4">{item.subModulo === 0 ? "NFCe" : item.subModulo}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center p-4 text-muted">
                  Nenhum relatório encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      ) : (
        <Placeholder animation="glow" className="mt-4">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </Container>
  );
};

export default RelatorioSistemaView;
